export default __webpack_public_path__ + "static/media/MANGAGO.44a5d818.png";